import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ai-tabs__discount"
}

import { computed, PropType } from 'vue';
import { TTabItem } from '@/types/TTabItem';

type TTabsType = 'rounded' | 'default' | 'square' | '';


export default /*@__PURE__*/_defineComponent({
  __name: 'AiTabs',
  props: {
  modelValue: {
    type: [String, Boolean, Number] as PropType<string | boolean | number>,
    required: true,
  },
  type: {
    type: String as PropType<TTabsType>,
    required: false,
    default: 'default',
  },
  items: {
    type: Array as PropType<TTabItem[]>,
    required: false,
    default: () => [],
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const value = computed({
  get() {
    return props.modelValue;
  },
  set(newVal) {
    emit('update:modelValue', newVal);
  },
});

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!

  return (_openBlock(), _createBlock(_component_v_tabs, _mergeProps({
    modelValue: value.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
    class: [{
      'ai-tabs--rounded': props.type === 'rounded',
      'ai-tabs--square': props.type === 'square',
      'ai-tabs--default': props.type === 'default',
      'ai-tabs': props.type === '',
    }, "ai-tabs"],
    "hide-slider": "",
    "fixed-tabs": "",
    touchless: ""
  }, _ctx.$attrs), {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item) => {
        return (_openBlock(), _createBlock(_component_v_tab, {
          class: "ai-tabs__item",
          key: item.value.toString(),
          value: item.value,
          "selected-class": "ai-tabs__item--active"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(item.label), 1),
            (item.discount)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(item.discount), 1))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["value"]))
      }), 128))
    ]),
    _: 1
  }, 16, ["modelValue", "class"]))
}
}

})